import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Typography, Paper } from '@mui/material';
import { User } from 'src/interfaces/iuser';
import MarketExplorerPage from '../MarketExplorer/MarketExplorer';
import MarketCompareTool from './MarketCompareTool';

// ===============================
// Main component
// ===============================

const MarketComparePage = ({
  user,
  search,
  currency,
  isLoggedIn,
  dummyMarket,
  OnBoardingSearchBox,
  handleOnSampleClick,
  setSubscriptionModalOpen,
  isMobileScreen,
  headerNav,
  handleUrlReDirection,
  source,
  handleReport,
  isMarketCompareTabManuallyClicked,
}: {
  user: User;
  search?: any;
  currency: string;
  isLoggedIn: boolean;
  dummyMarket;
  OnBoardingSearchBox;
  handleOnSampleClick;
  setSubscriptionModalOpen;
  isMobileScreen: boolean;
  headerNav?: () => JSX.Element;
  handleUrlReDirection?;
  source;
  handleReport?: (
    method: any,
    requestBody: null | any,
    id?: string,
    storeID?: boolean,
    hideLoading?: boolean
  ) => Promise<void>;
  setReportComparePageClose?: () => void;
  isMarketCompareTabManuallyClicked?: boolean;
}) => {
  const [mode, setMode] = useState<'explore' | 'compare'>('explore');

  useEffect(() => {
    if (source == 'report') {
      setMode('compare');
    }
  }, [source]);

  return (
    <Grid container>
      {mode === 'explore' ? (
        <MarketExplorerPage
          currency={currency}
          handleOnSampleClick={handleOnSampleClick}
          isMobileScreen={isMobileScreen}
        />
      ) : (
        <MarketCompareTool
          isMobileScreen={isMobileScreen}
          source={source}
          headerNav={headerNav}
          OnBoardingSearchBox={OnBoardingSearchBox}
          handleOnSampleClick={handleOnSampleClick}
          currency={currency}
          isLoggedIn={isLoggedIn}
          isMarketCompareTabManuallyClicked={isMarketCompareTabManuallyClicked}
        />
      )}

      <Grid item xs={12} display="flex" justifyContent="center" alignItems="flex-start">
        {mode === 'explore' ? (
          <Paper
            elevation={3}
            sx={{
              p: 4,
              maxWidth: 600,
              textAlign: 'center',
              borderRadius: 2,
              mb: '100px'
            }}
          >
            <Typography variant="h6" gutterBottom>
              Have specific markets in mind?
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Use our original comparison tool to view detailed metrics side-by-side across up to 20
              markets.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => setMode('compare')}
              sx={{ mt: 2 }}
            >
              Open Market Comparison Tool
            </Button>
          </Paper>
        ) : (
          <Box
            sx={{
              p: 4,
              maxWidth: 600,
              textAlign: 'center',
              mb: '100px'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => setMode('explore')}
            >
              Back to Market Explorer
            </Button>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default MarketComparePage;
